import { AKTIVE_STATUS, type AktiverStatus, type BatchFilter } from '@autopilot/contracts';
import { VORGANG_STATUS_LABEL } from './labels';

/** Auswählbare Status: ausschließlich die fünf aktiven. GELOEST/GESCHLOSSEN sind nie Teil der Liste. */
export const SELECTABLE_STATUSES: readonly AktiverStatus[] = AKTIVE_STATUS;

export function defaultFilter(): BatchFilter {
  return {
    gesellschaftIds: [],
    vorgangstypIds: [],
    includeUntyped: false,
    statuses: [...AKTIVE_STATUS],
    createdFromDate: null,
    createdToDate: null,
    assignment: 'ALL',
  };
}

/** Entfernt nicht auswählbare Status (z. B. aus manipulierten URL-Parametern). */
export function sanitizeStatuses(values: readonly string[]): AktiverStatus[] {
  return values.filter((v): v is AktiverStatus => (SELECTABLE_STATUSES as readonly string[]).includes(v));
}

export function validateDateRange(from: string | null, to: string | null): string | null {
  if (from && to && from > to) return '„Erstellt bis“ darf nicht vor „Erstellt von“ liegen.';
  return null;
}

export type NameLookup = { gesellschaften: Map<string, string>; typen: Map<string, string> };

export function summarizeFilter(f: BatchFilter | null | undefined, names?: NameLookup): string {
  if (!f) return '–';
  const parts: string[] = [];
  parts.push(
    f.gesellschaftIds.length === 0
      ? 'Alle Gesellschaften'
      : f.gesellschaftIds.map((id) => names?.gesellschaften.get(id) ?? 'Gesellschaft').join(', '),
  );
  const typen = f.vorgangstypIds.map((id) => names?.typen.get(id) ?? 'Typ');
  if (f.includeUntyped) typen.push('Ohne Typ');
  parts.push(typen.length === 0 ? 'alle Typen' : typen.join(', '));
  const st = f.statuses.length === 0 || f.statuses.length === AKTIVE_STATUS.length ? 'alle aktiven Status' : f.statuses.map((s) => VORGANG_STATUS_LABEL[s]).join(', ');
  parts.push(st);
  if (f.createdFromDate || f.createdToDate) {
    parts.push(`erstellt ${f.createdFromDate ? `ab ${f.createdFromDate.split('-').reverse().join('.')}` : ''}${f.createdFromDate && f.createdToDate ? ' ' : ''}${f.createdToDate ? `bis ${f.createdToDate.split('-').reverse().join('.')}` : ''}`);
  }
  parts.push(f.assignment === 'UNASSIGNED' ? 'nur unassigned' : 'alle Tickets');
  return parts.join(' · ');
}
